// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as selectors from '../../modules/selectors';
// import Facebook from '../Icons/Facebook';
// import Twitter from '../Icons/Twitter';
import Close from '../Icons/Close';
import colors from '../../assets/css/colors';
import TrashCan from '../Icons/TrashCan';
import Lock from '../Icons/Lock';
import {
	TeamUserAvatar,
	TeamUserAvatarWrapper,
	TeamName,
	LoadingSpinner,
	TableGrid,
	TableFlexHeading,
	TableFlexBody,
	TableFlexRow,
	PlayerTableCell,
	RotatedLabel,
	PlayerInfo,
	BenchTitle,
	// SocialLink,
	FilledIcon
} from '../';
import { getSquadSize } from '../../helpers/league';
import { getLineupPlayersCount } from '../../helpers/complex/team';

const TableFlexRowStyled = styled(TableFlexRow)`
	${({ is_on_trade }) => {
		return is_on_trade ? `
			background: ${colors.lightGrey};
			> div {
				opacity: .5;
			}
			> div:first-child {
				opacity: 1;

				> div:first-child {
					opacity: 1;
				}
				> div {
					opacity: .5;
				}
			}
			> div:last-child {
				opacity: 1;
			}
		` : '';
	}}
`;

type TableColumns = Array<{ key: string, prop: string }>;

type Props = {
	team: Object,
	league: Object,
	table: {
		basic: TableColumns,
		coach: TableColumns,
	},
	actual_round: Object,
	lineup_players: Object,
	emergency_arr: Array<number>,
	addOutTrade: Function,
	removeOutPlayer: Function,
	fa: Object,
	is_league_started: boolean
};

type State = {
};

export class TeamForTradePage extends React.Component<Props, State> {

	static defaultProps = {
		players: [],
		table: {
			basic: [
				{ key: 'AVG', prop: 'stats.avg_points' },
				{ key: 'PLD', prop: 'stats.games_played' },
				{ key: 'TOT', prop: 'stats.total_points' },
				{ key: 'L5 AVG', prop: 'stats.last_5_avg' },
				{ key: 'AVG DP', prop: 'stats.adp' },
			],
			coach: [],
		},
		team: {},
		league: {}
	};
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'getTableSection',
			'getTableRow',
		]);
	}
	get team_data() {
		const { team } = this.props;

		if (_.isEmpty(team)) {
			return null;
		}
		return (
			<React.Fragment>
				<TeamUserAvatar user_id={team.user_id} avatar_version={team.avatar_version} />
				<TeamName>
					{team.name}
				</TeamName>
			</React.Fragment>
		);
	}
	get team_size() {
		const { team, league } = this.props;

		if (_.isEmpty(team) || _.isEmpty(league)) {
			return null;
		}
		const { lineup } = team,
			current = getLineupPlayersCount({ lineup }),
			total = getSquadSize(league);

		return (<p>{current}/{total}</p>);
	}
	get share_icons() {
		// *Commented due to following ticket:
		// *https://fanhub.atlassian.net/browse/NRLDRAFT-531
		return null;
		// (
		// 	<React.Fragment>
		// 		<SocialLink
		// 			target="_blank"
		// 			aria-label="Follow"
		// 			className="hidden-mobile"
		// 			border_color={colors.nrlDarkGreen}
		// 		>
		// 			<Facebook size="1.2" />
		// 		</SocialLink>
		// 		<SocialLink
		// 			target="_blank"
		// 			aria-label="Twitter"
		// 			className="hidden-mobile"
		// 			border_color={colors.nrlDarkGreen}
		// 		>
		// 			<Twitter size="1.2" />
		// 		</SocialLink>
		// 	</React.Fragment>
		// );
	}
	get table_keys() {
		return this.props.table.basic;
	}
	get table_header() {
		const cells = this.table_keys.map(({ key, prop }) => (
			<PlayerTableCell key={key}
				width="50px"
				className={key === 'AVG' ? '' : 'hidden-mobile'}
			>
				<span className="column-name">{key}</span>
			</PlayerTableCell>
		));

		return (
			<TableFlexHeading height="50px">
				<PlayerTableCell width="260px" justify="flex-start">
					Starting Side
				</PlayerTableCell>
				{ cells }
				<PlayerTableCell width="60px">Remove</PlayerTableCell>
			</TableFlexHeading>
		);
	}
	get table_body() {
		const { team, lineup_players } = this.props;
		const { lineup } = team;

		if (!lineup || _.isEmpty(lineup_players)) {
			return <LoadingSpinner />;
		}
		const lineup_pure = _.omit(lineup, ['captain', 'vice_captain', 'bench', 'emergency']);
		const bench = _.get(lineup, 'bench');

		return (
			<TableFlexBody>
				{_.map(lineup_pure, this.getTableSection)}
				<BenchTitle>
					Bench
				</BenchTitle>
				{_.map(bench, id => this.getTableRow(
					{ id, is_bench: true, is_agent: false }
				))}
			</TableFlexBody>
		);
	}
	getTableSection(line: Array<number>) {
		return line.map(id => this.getTableRow(
			{
				id,
				is_bench: false
			}
		));
	}
	getTableRow({ id, is_bench }: Object) {
		const {
				lineup_players,
				league,
				team: { lineup: { captain, vice_captain } },
				emergency_arr,
				fa
			} = this.props,
			is_on_trade = fa.old_player_id === id,
			player = lineup_players[id],
			is_captain = captain === id,
			is_vice_captain = vice_captain === id,
			is_emergency_enabled = league.emergency && is_bench,
			is_emergency = emergency_arr ? emergency_arr.includes(id) : false;

		if (!player) {
			return (
				<TableFlexRow key={id}>
					<LoadingSpinner />
				</TableFlexRow>
			);
		}

		return (
			<TableFlexRowStyled key={id} is_on_trade={is_on_trade}>
				<PlayerTableCell width="260px" height="60px" justify="flex-start">
					<RotatedLabel
						is_captain={is_captain}
						is_vice_captain={is_vice_captain}
						is_emergency_enabled={is_emergency_enabled}
						is_emergency={is_emergency}
						text={player.position_in_lineup}
						rotate="-90" />
					<PlayerInfo player={player} />
				</PlayerTableCell>
				{this.table_keys.map(({ key, prop }) => (
					<PlayerTableCell key={key} width="50px" height="60px"
						className={key === 'AVG' ? '' : 'hidden-mobile'}
					>
						{_.get(player, prop, '--')}
					</PlayerTableCell>
				))}
				{this.getControls({ id })}

			</TableFlexRowStyled>
		);
	}

	getControls({ id }: Object) {
		const {
				removeOutPlayer,
				addOutTrade,
				fa,
			} = this.props,
			is_on_trade = fa.old_player_id === id;

		if (!this.isCanTrade({ id })) {
			return (
				<PlayerTableCell
					position="relative"
					width="60px"
					height="60px"
				>
					<Lock color={colors.icon_grey} />
				</PlayerTableCell>
			);
		}

		return is_on_trade ? (
			<PlayerTableCell
				position="relative"
				width="60px"
				height="60px"
				onClick={() => removeOutPlayer({ id, is_user_team: true })}
			>
				<FilledIcon
					background={colors.red}
					className="filled-icon"
				>
					<TrashCan color="#fff" />
				</FilledIcon>
			</PlayerTableCell>
		) : (
			<PlayerTableCell
				position="relative"
				width="60px"
				height="60px"
				onClick={() => addOutTrade({ id, is_user_team: true })}
			>
				<Close color={colors.icon_grey} />
			</PlayerTableCell>
		);
	}
	isCanTrade({ id }: Object) {
		const {
				league: { lockout },
				is_league_started,
				lineup_players,
				team: { lineup: { captain, vice_captain } },
				actual_round: { status }
			} = this.props,
			is_not_scheduled_round = status !== 'scheduled',
			player = lineup_players[id],
			is_captain = captain === id,
			is_vice_captain = vice_captain === id,
			is_locked = player.locked || is_captain || is_vice_captain,
			is_lockout = lockout ? (is_not_scheduled_round && is_locked) : (is_not_scheduled_round && player.is_playing_now);

		if (!is_league_started) {
			return true;
		}

		return !is_lockout;
	}

	render() {
		return (
			<React.Fragment>
				<TeamUserAvatarWrapper>
					{this.team_data}
					{this.team_size}
					{this.share_icons}
				</TeamUserAvatarWrapper>

				<div>
					<TableGrid>
						{this.table_header}
						{this.table_body}
					</TableGrid>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, props) => {
	// console.log(state);
	return {
		isPending: state.leagues.show.isPending,
		team: selectors.complex.team.getUserTeamFromTeamsById(state, props),
		user_id: state.user.data.id,
		has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
		actual_round: selectors.rounds.getSelectedRound(state),
		lineup_players: selectors.complex.team.getUserPlayersFromLineup(state, props),
		emergency_arr: selectors.complex.team.getEmergencyArray(state),
		is_league_started: selectors.leagueDraft.isLeagueStarted(state, props),
	};
};
export const TeamForTrade = withRouter(
	connect(mapStateToProps)(TeamForTradePage)
);
export default TeamForTrade;


// WEBPACK FOOTER //
// ./src/components/Team/TeamForTrade.js